import { FC, PropsWithChildren } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { MenuList, MenuProps, Typography } from '@mui/material';
import { useBreakpoints } from 'hooks';

import { BottomSlider } from 'components/_basic/BottomSlider';

import { MenuStyled, TitleMenuItem } from './styled';

export interface ISelectorContentViewProps extends PropsWithChildren {
  isOpened: boolean;
  onClose: VoidFunction;
  anchorEl?: MenuProps['anchorEl'];
  title: string;
}

const MobileView: FC<ISelectorContentViewProps> = ({ children, isOpened, onClose, title }) => {
  return (
    <BottomSlider isOpened={isOpened} onClose={onClose}>
      <MenuList sx={{ p: 0 }}>
        <Typography variant="body1" fontWeight={600} component={TitleMenuItem}>
          {title}
        </Typography>
        {children}
      </MenuList>
    </BottomSlider>
  );
};

const DesktopView: FC<ISelectorContentViewProps> = ({ children, isOpened, onClose, anchorEl, title }) => {
  const { i18n } = useTranslation();
  return (
    <MenuStyled anchorEl={anchorEl} open={isOpened} onClose={onClose} isEng={i18n.language === 'en'}>
      <Typography variant="subtitle2" component={TitleMenuItem}>
        {title}
      </Typography>
      {children}
    </MenuStyled>
  );
};

export const SelectorContentView: FC<ISelectorContentViewProps> = (props) => {
  const { isMobile } = useBreakpoints();

  const SelectorContentViewComponent = isMobile ? MobileView : DesktopView;

  return <SelectorContentViewComponent {...props} />;
};
